var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"taxprofile"},[_c('Tax',{ref:"taxProfileRef",attrs:{"level":_vm.showMenuType,"isOPS":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }